import Head from 'next/head';
import Link from 'next/link';
import Logo from './Logo';

/**
 * Impalcatura comune delle pagine informative (privacy, termini, contatti):
 * intestazione con logo, corpo in colonna stretta, piede minimo.
 */
export default function PaginaInformativa({
  titolo,
  sottotitolo,
  aggiornamento,
  children
}) {
  return (
    <div className="min-h-screen bg-body text-foreground">
      <Head>
        <title>{`${titolo} — Dimora`}</title>
      </Head>

      <header className="border-b border-border bg-card">
        <div className="mx-auto flex h-16 w-full max-w-4xl items-center justify-between px-5">
          <Link href="/" aria-label="Torna alla pagina principale">
            <Logo size="sm" />
          </Link>
          <Link
            href="/signin"
            className="text-sm font-medium text-primary hover:underline"
          >
            Prova la demo
          </Link>
        </div>
      </header>

      <main className="mx-auto w-full max-w-2xl px-5 py-12 md:py-16">
        <h1 className="text-3xl font-semibold tracking-tight">{titolo}</h1>
        {sottotitolo ? (
          <p className="mt-2 text-muted-foreground">{sottotitolo}</p>
        ) : null}
        {aggiornamento ? (
          <p className="mt-1 text-xs text-muted-foreground">
            Ultimo aggiornamento: {aggiornamento}
          </p>
        ) : null}
        <div className="mt-8 space-y-6 leading-relaxed text-secondary-foreground">
          {children}
        </div>
      </main>

      <footer className="border-t border-border">
        <div className="mx-auto flex w-full max-w-4xl flex-wrap items-center justify-between gap-3 px-5 py-6 text-xs text-muted-foreground">
          <span>Dimora — ambiente dimostrativo di Giuseppe Delli Paoli</span>
          <nav className="flex gap-4">
            <Link href="/privacy" className="hover:text-foreground">
              Privacy
            </Link>
            <Link href="/termini" className="hover:text-foreground">
              Termini
            </Link>
            <Link href="/contatti" className="hover:text-foreground">
              Contatti
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export function Sezione({ titolo, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-semibold text-foreground">{titolo}</h2>
      {children}
    </section>
  );
}
